/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { SharedDocsDto } from './shared-docs.dto';
import { SharedDocsMapper } from './shared-docs.mapper';

@Injectable()
export class SupplierSharedDocsRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  getAll(): SlicedDataSource<SharedDocsDto> {
    return this.createSlicedDataSourceGet(
      `/job/docs`,
      arrayOf(SharedDocsMapper),
    );
  }
}
